import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerDepartmentService } from '../../services/wealthlane-customer-services';

const useGetCustomerDepartmentList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const CustomerDepartmentCustomerDepartmentList = useQuery(
    ['getCustomerDepartmentCustomerDepartmentList'],
    async () => {
      return await handleRequest(
        CustomerDepartmentService.getApiCustomerApiAppCustomerDepartmentCustomerDepartmentList()
      );
    },
    {
      select: (data) => {
        return data?.items?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return CustomerDepartmentCustomerDepartmentList;
};

export default useGetCustomerDepartmentList;
